module.exports = __webpack_public_path__ + "assets/img/dottedline-short.0c8cb7cd.svg";